import { MessageformatConfig } from '@ngneat/transloco-messageformat';

export const CUSTOM_FORMATTERS: MessageformatConfig['customFormatters'] = {
  upcase: {
    formatter: v => (typeof v === 'string' ? v.toUpperCase() : v),
    arg: 'string'
  },
  lowcase: {
    formatter: v => (typeof v === 'string' ? v.toLowerCase() : v),
    arg: 'string'
  }
};
